export const WITH_DEFAULT_LOGO = [12862249, 39840914, 1706302, 13273555, 7032954, 48460021, 14179199];
